import { CellProps } from '@/components/bulkQueue/types';
import { OrderChip } from '@/components/orders/OrderChip';
import { Typography } from '@mui/material';
import { FC } from 'react';

export const OrderRenderCell: FC<CellProps> = (props) => {
    const { order } = props.entity;

    if (order) {
        return <OrderChip order={order} />;
    }

    return <Typography fontSize={'14px'}>None</Typography>;
};
